import { useCallback } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Matchmaker Taste Privacy notice — tracked once GLOBALLY via a single user
// field (same pattern as useFilterTooltipSeen), so whichever surface shows
// it first (the in-app banner for existing members, or the onboarding
// "taste" step for new members) marks it seen for both.
export function useMatchmakerPrivacyNotice() {
  const { user, setUser } = useAuth();
  const seen = !!user?.matchmaker_privacy_notice_seen;
  const markSeen = useCallback(() => {
    if (seen) return;
    client.put("/auth/profile", { matchmaker_privacy_notice_seen: true }).then((r) => setUser(r.data)).catch(() => {});
  }, [seen, setUser]);
  return { seen, markSeen };
}
